import PropTypes from 'prop-types';

import { HX } from '../Headings';

const typesCSS = {
  danger: 'bg-red-4 text-white',
  default: 'bg-black text-white',
  info: 'bg-blue-3 text-white',
  pantheor: 'bg-purple-4 text-white',
  warning: 'bg-orange-3 text-black',
};

const PanelHeader = ({ children, level, levelStyle, type }) => (
  <HX
    className={`flex justify-center p-4 rounded-t rounded-b-none -mt-4 mb-4 -mx-4 ${typesCSS[type]}`}
    level={level}
    levelStyle={levelStyle}
  >
    {children}
  </HX>
);

PanelHeader.defaultProps = {
  levelStyle: 4,
  type: 'default',
};

PanelHeader.propTypes = {
  children: PropTypes.node.isRequired,
  level: PropTypes.oneOf([1, 2, 3, 4, 5, 6]).isRequired,
  levelStyle: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  type: PropTypes.oneOf(['danger', 'default', 'info', 'pantheor', 'warning']),
};

export default PanelHeader;
